<template>
    <div><!-- 試作準備 -->
        <CCard class="w-100">
            <CCardHeader>
                <strong>{{$t('TrialProduction.TrialProduction')}}</strong>
            </CCardHeader>
            <CCardBody>
                    <CForm>
                        <div class="CForminline">
                            <div class="factory">
                                <p>{{$t('QuoteInfo_Vue.FactoryType')}}：</p>
                                <div v-for="(item, key) in factoryList" :key="'factoryType_input_' + key">
                                    <input :disabled ="disableFactory" type="radio" :name="'trialProd_FactoryTypeOpt'" v-model="trialQueryParam.factoryId" :value="item.factoryId" >{{getFactoryCaption(item.factoryId,item.factoryCaption)}}
                                </div>
                            </div>
                            <div class="name">
                                <p>{{$t('QualityInfo_Vue.RoeModel')}}：</p>
                                <input type="text" maxlength="50"  v-model="trialQueryParam.roeModel">
                            </div>
                            <div class="btn_group">
                                <button type="button" class="btn btn-edit mr-2" @click="trialQueryEvent">{{$t('Buttons.Query')}}</button>
                                <button type="button" class="btn btn-success mr-2" @click="trialExportEvent">{{$t('Buttons.ExportOrder')}}</button>
                            </div>                            
                        </div>
                    </CForm>
            </CCardBody>
        </CCard>
    </div>
</template>

<script>
import { qualityMixin } from '@/mixin/quality'
import { mapGetters } from 'vuex'
export default {
    mixins: [qualityMixin],	
    data() {
        return {            
            factoryList: this.$t('factoryQMList'), //廠別 清單
            trialQueryParam: {
                hadQuery : false,
                factoryId: '' , 
                roeModel:''
            }            
        }
    },
    props : {
    },
    watch: {
        "lang": function() {
            this.factoryList = this.$t('factoryQMList') //廠別 清單
        }
    },
    methods: {
        trialQueryEvent (){      
            this.trialQueryParam.hadQuery = true;      
            this.$emit('trialQueryEvent',this.trialQueryParam);
        },        
        trialExportEvent (){//匯出            
            this.$emit('trialExportEvent',this.trialQueryParam);
        }
    },
    computed: {
        ...mapGetters(["lang"])
    },
	mounted() {
        this.getCacheQueryParam('Trial_QueryParam' , this.trialQueryParam);        
        const userFactoryId= this.userFactoryId;
        if(userFactoryId){
            this.trialQueryParam.factoryId = userFactoryId;
        }
        if(this.trialQueryParam.hadQuery){
            this.trialQueryEvent(); 
        }
	},
    created() {        
    }
}
</script>

<style lang="scss" scoped>
.CForminline {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: center;
    > .form-group {
        margin-bottom: 0;
    }

    > .name, .factory, .supplier, .watch, .check {
        display: flex;
        align-items: center;
        margin: .5rem 0;
        // width: 350px;

        > p {
            margin-right: 1rem;
            margin-bottom: 0;
        }
        > .purchase_input {
            margin-bottom: 0;
        }
        > input {
            flex: 1;
            margin: 0 .5rem;
        }
        > div {
            margin: 0 .5rem;
        }        
    }
}

.purchase {
    width: 100%;
}

.btn-edit {
    background-color: #343b55;
    color: white;
}
</style>
